import { c as _c } from "react/compiler-runtime";
import { type ComponentType, type ReactNode } from 'react';
import { usePathname as useNextPathname } from 'next/navigation';
import { RetainDefaultQueryLink } from 'shared/components/Router';
import { useBreadcrumbsPathProps } from 'shared/hooks/useBreadcrumbsPathProps';
interface BreadcrumbPathProps {
  label: string;
  path: string;
}
interface UseBreadcrumbsProps {
  currentPath: string;
  pathProps: BreadcrumbPathProps[];
  Link: ComponentType<{
    href: string;
    children: ReactNode;
  }>;
}
export const useBreadcrumbs = () => {
  const $ = _c(3);
  const pathname = useNextPathname() ?? "";
  const pathProps = useBreadcrumbsPathProps();
  let t0;
  if ($[0] !== pathProps || $[1] !== pathname) {
    t0 = {
      currentPath: pathname,
      pathProps,
      Link: _temp
    };
    $[0] = pathProps;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
function _temp(props) {
  return <RetainDefaultQueryLink href={props.href}>{props.children}</RetainDefaultQueryLink>;
}